import { render } from "./modell-selector-accessories.vue?vue&type=template&id=64259bb9"
import script from "./modell-selector-accessories.vue?vue&type=script&lang=js"
export * from "./modell-selector-accessories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__